import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        lang: (navigator.language || navigator.userLanguage || 'en').substr(0,2),
    },
    getters: {
        lang: state => state.lang,
    },
    mutations: {
        ['SET_LANGUAGE'] (state, { lang, wordset }) {
            state.lang = lang
        }
    },
    actions: {
        setLang(ctx, { lang }) {
            ctx.commit('SET_LANGUAGE', { lang })
        }
    },
    strict: true
})